import { useEffect, useState } from 'react';

import { USE_CLOCK_TICK_INTERVAL_MS } from '@constants/hooks';
import { formatDate } from '@utils/date';

import { useAppSelector } from '@hooks';

export const useClock = () => {
  const [clock, setClock] = useState(new Date());
  const timezone = useAppSelector((state) => state.appConfig.config.timezone);

  useEffect(() => {
    const id = setInterval(() => {
      setClock(new Date());
    }, USE_CLOCK_TICK_INTERVAL_MS);

    return () => {
      clearInterval(id);
    };
  }, []);

  return formatDate(clock, { timezone });
};
